import { createStore } from "redux";
import throttle from "lodash.throttle";
import {
  loadState,
  saveState,
  GET_NAVIGATION,
  SET_NAVIGATION,
  PUSH_SUBNAVIGATION,
  TOGGLE_NAV,
  SET_SUBHEADER_COMPONENTS,
  CLEAR_SUBHEADER_COMPONENTS,
  DELETE_SUBHEADER_COMPONENT,
} from "./localStorage";
import config from "./config/config.json";

export const initialStoreState = {
  menus: undefined,
  links: undefined,
  schemas: undefined,
  widgets: undefined,
  accessToken: undefined,
  profile: undefined,
  sidebarShow: false,
  sidebarCount: 0,
  viewUrl: undefined,
  viewId: "",
  viewLoading: true,
  view: undefined,
  viewError: undefined,
  params: undefined,
  widgetState: undefined,
  editMode: false,
  editBreakpoint: undefined,
  currentBreakpoint: "lg",
  inactivityModal: false,
  addWidget: false,
  userCanUpdate: false,
  userCanDelete: false,
  saveView: false,
  version: config.version,
  referrer: false,
  navigation: {
    pathname: "",
    url: "",
    pathId: "",
    icon: "",
  },
  navData: undefined,
  cacheSet: undefined,
  cache: {
    subNavigations: [],
  },
  isToggled: false,
  subheaderComponents: [],
};

function updateComponents(oldComponents, newComponents) {

  if (JSON.stringify(oldComponents) === JSON.stringify(newComponents)) return oldComponents;

  const idMap = new Map();

  for (const item of oldComponents) {
    const id = `${item.widgetId}-${item.name}`;
    idMap.set(id, item);
  }

  for (const item of newComponents) {
    const id = `${item.widgetId}-${item.name}`;
    idMap.set(id, item);
  }

  return Array.from(idMap.values());
}

const changeState = (
  state = initialStoreState,
  { type, navigation, subNavigation, components, widgetId, ...rest }
) => {
  switch (type) {
    case "set":
      return { ...state, ...rest };
    case TOGGLE_NAV:
      return { ...state, isToggled: rest.open };
    case SET_NAVIGATION:
      return { ...state, navigation: { ...state.navigation, ...navigation } };
    case GET_NAVIGATION:
      return state.navigation;
    case PUSH_SUBNAVIGATION:
      const isSubNavigationExist = state?.cache?.subNavigations?.some(
        (item) => item.id === subNavigation.id
      );
      if (!isSubNavigationExist) {
        return {
          ...state,
          cache: {
            ...state.cache,
            subNavigations: [
              ...(state?.cache?.subNavigations ?? []),
              { id: subNavigation.id, subNavs: subNavigation.subNavs },
            ],
          },
        };
      }
      return state;
    case SET_SUBHEADER_COMPONENTS: {
      const existingComponents = new Set(
        state.subheaderComponents.map(
          (component) => `${component.widgetId}-${component.name}`
        )
      );
      return {
        ...state,
        subheaderComponentsData: updateComponents([...state.subheaderComponents], [...components]),
        subheaderComponents: [
          ...state.subheaderComponents,
          ...components.filter((component) => {
            const componentKey = `${component.widgetId}-${component.name}`;
            if (existingComponents.has(componentKey)) {
              return false;
            } else {
              existingComponents.add(componentKey);
              return true;
            }
          }),
        ],
      };
    }
    case DELETE_SUBHEADER_COMPONENT:
      return {
        ...state,
        subheaderComponents: state.subheaderComponents.filter(
          (component) => component.widgetId !== widgetId
        ),
      };
    case CLEAR_SUBHEADER_COMPONENTS:
      return { ...state, subheaderComponents: [] };
    default:
      return state;
  }
};

const store = createStore(changeState, loadState());

store.subscribe(
  throttle(() => {
    saveState(store.getState());
  }, 1000)
);

export default store;
